export default class GA4 {
    dispatch(event) {
        this.dataLayer().push({event: event})
    }

    dataLayer() {
        return window.dataLayer || [];
    }
}
